import { render, staticRenderFns } from "./CorrectIcon.vue?vue&type=template&id=cb8326ae"
import script from "./CorrectIcon.vue?vue&type=script&lang=ts"
export * from "./CorrectIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports